import { formatCurrency, getLabelFromStorage } from '@pb/utils'

import { OrderTotals } from '../../types'

const isFormattedApiEnabled = process.env.IS_FORMATTERS_API_ENABLED === 'enabled'

export const shouldShowMaxTaxOrTBD = (
  orderTotals: OrderTotals,
  isExternalTaxApplied: boolean,
): boolean => {
  return !!(
    orderTotals.showMaxTax ||
    orderTotals.showTaxToBeDefined ||
    (isExternalTaxApplied && !orderTotals.totalTax)
  )
}

export const shouldNotShowTotalTax = (
  orderTotals: OrderTotals,
  shouldShowTax: boolean,
): boolean => {
  if (!shouldShowTax) return true
  return !!(orderTotals.impositionType || orderTotals.showMaxTax || orderTotals.showTaxToBeDefined)
}

export const getValueForLabel = (
  labelKey: string,
  amount: number,
  formattedValue: string,
): string => {
  if (labelKey === getLabelFromStorage('basket.page.delivery.standard') && amount === 0) {
    return getLabelFromStorage('basket.page.free')
  }
  if (labelKey === getLabelFromStorage('checkout.orderTotal.maxTax.estimated') && amount === 0) {
    return getLabelFromStorage('sidecart.taxes.to.be.defined.TBD')
  }

  // Formatted Api should not be used for serbian currency (RSD)
  const shouldFormattedApiBeUsed = isFormattedApiEnabled && !formattedValue.includes('RSD')
  return shouldFormattedApiBeUsed ? formatCurrency(amount) : formattedValue
}
